export const CONTEXT_APP = 'app'
export const CONTEXT_WEB = 'ecommerce'
